import React from "react";
import { Box, Typography } from "@mui/material";
import { typeVariant } from "../../config/theme";

interface EmptyStateProps {
  /** Optional leading icon (e.g. an MUI outlined icon). */
  icon?: React.ReactNode;
  title: string;
  /** Secondary explanatory line. */
  hint?: string;
  /** Optional call-to-action (button/link). */
  action?: React.ReactNode;
  /** Compact variant for inside table/card bodies. */
  dense?: boolean;
}

/**
 * Consistent per-page / per-section empty state. Replaces ad-hoc
 * "No results" strings so every empty surface looks the same.
 */
export default function EmptyState({ icon, title, hint, action, dense = false }: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
        py: dense ? 4 : 8,
        px: 2,
        color: "text.secondary",
      }}
    >
      {icon && (
        <Box sx={{ color: "text.disabled", "& svg": { fontSize: dense ? 32 : 44 } }}>{icon}</Box>
      )}
      <Typography sx={{ ...typeVariant(dense ? "subheading" : "heading"), color: "text.primary" }}>
        {title}
      </Typography>
      {hint && (
        <Typography variant="body2" sx={{ color: "text.secondary", maxWidth: 420 }}>
          {hint}
        </Typography>
      )}
      {action && <Box sx={{ mt: 1 }}>{action}</Box>}
    </Box>
  );
}
